<template>
  <div>
    <el-row
      id="course-apply"
      class="cs-contentContainer"
    >
      <el-col
        :span="4"
        class="cs-main-left-container"
      >
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">课程报名</span>
                <el-row class="cs-filter-row">
                  <el-col :span="16">
                    <el-row>
                      <el-form :inline="true">
                        <el-form-item label="手机号码">
                          <el-input
                            placeholder="手机号码"
                            v-model="phone"
                            size="medium"
                            clearable
                            class="phone-input"
                          ></el-input>
                        </el-form-item>
                        <el-form-item>
                          <el-button
                            @click="search()"
                            type="primary"
                            size="medium"
                          >查询</el-button>
                        </el-form-item>
                      </el-form>
                    </el-row>
                    <el-row>
                      <div
                        v-if="!validateExist"
                        class="label-not-exist"
                      >此号码未注册速成账号</div>
                    </el-row>
                    <el-row v-if="student.Id>0 && validateExist">
                      <el-form :inline="true">
                        <el-form-item label="当前学期">
                          <span>{{terms[0].DisplayLable}}</span>
                        </el-form-item>
                      </el-form>
                    </el-row>

                    <div
                      class="loading"
                      v-loading="loading || saving"
                    >
                      <el-card class="box-card">
                        <div
                          slot="header"
                          class="clearfix"
                        >
                          <span>大学课程</span>
                          <font
                            class="hand"
                            @click="addCourse()"
                          ><i class="el-icon-plus add-course-icon"></i> 添加课程</font>
                        </div>
                        <el-row
                          v-for="(item, index) in speedupCourseApplyList"
                          :key="index"
                          class="row-course-card"
                        >
                          <!-- <img v-if="item.Id" class="img-completed" src="../../assets/completed.png"> -->
                          <el-container class="course-container">
                            <el-aside style="width:30%"></el-aside>
                            <el-container>
                              <el-main>
                                <el-form
                                  :model="item"
                                  label-width="100px"
                                >
                                  <el-form-item label="学校:">
                                    <label>{{item.UniversityName}}</label>
                                  </el-form-item>
                                  <el-form-item label="学期:">
                                    <el-select
                                      @change="changeTerm(item,index)"
                                      v-model="item.TermId"
                                      placeholder="请选择学期"
                                    >
                                      <el-option
                                        v-for="term in terms"
                                        :key="term.Id"
                                        :label="term.DisplayLable"
                                        :value="term.Id"
                                      >
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                  <el-form-item label="课程名称:">
                                    <el-select
                                      filterable
                                      v-on:change="onChangeCourseId(item,index)"
                                      v-model="item.CourseId"
                                      placeholder="请选择课程"
                                    >
                                      <el-option
                                        v-for="course in getCoursesByTermId(item.TermId)"
                                        :key="course.Id"
                                        :label="course.Name"
                                        :value="course.Id"
                                      >
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                  <el-form-item label="速成老师:">
                                    <label>{{item.TeacherName}}</label>
                                  </el-form-item>

                                  <el-form-item v-show="item.editingMessage && item.editingMessage != '' && item.editingMessage.length>0">
                                    <el-alert
                                      :title="item.editingMessage"
                                      class="error-message"
                                      type="error"
                                      :closable="false"
                                    ></el-alert>
                                  </el-form-item>
                                  <el-form-item class="text-right">
                                    <a
                                      class="delete-btn"
                                      @click="removeCourse(item,index)"
                                    >删除</a>
                                  </el-form-item>
                                </el-form>
                              </el-main>
                            </el-container>
                          </el-container>
                        </el-row>
                      </el-card>
                      <el-card class="box-card">
                        <div
                          slot="header"
                          class="clearfix"
                        >
                          <span>应试英语训课程</span>
                          <font
                            class="hand"
                            @click="addEnglishCourse()"
                          ><i class="el-icon-plus add-course-icon"></i> 添加课程</font>
                        </div>
                        <speedupCourseTrainingEditor
                          v-for="(item, index) in englisthCourseList"
                          :key="index"
                          :modelData="item"
                          :index="index"
                          :campusList="campusList"
                          :courseCategroyList="englishCourseCategroyList"
                          @remove="onEnglishCourseRemove"
                          ref="englishEditor"
                          class="row-course-card"
                        >
                        </speedupCourseTrainingEditor>
                      </el-card>
                      <el-card class="box-card">
                        <div
                          slot="header"
                          class="clearfix"
                        >
                          <span>职业培训课程</span>
                          <font
                            class="hand"
                            @click="addTrainingCourse()"
                          ><i class="el-icon-plus add-course-icon"></i> 添加课程</font>
                        </div>
                        <speedupCourseTrainingEditor
                          v-for="(item, index) in trainingCourseList"
                          :key="index"
                          :modelData="item"
                          :index="index"
                          :campusList="campusList"
                          :courseCategroyList="trainingCourseCategroyList"
                          @remove="onTrainingCourseRemove"
                          ref="trainingEditor"
                          class="row-course-card"
                        >
                        </speedupCourseTrainingEditor>
                      </el-card>
                    </div>
                    <el-row
                      v-if="student.Id>0 && validateExist"
                      class="row-course-card"
                    >
                      <font
                        class="hand"
                        @click="addTrainingCourse()"
                      ><i class="el-icon-plus add-course-icon"></i> 添加课程
                      </font>
                    </el-row>

                    <el-row
                      v-if="student.Id>0 && validateExist"
                      class="row-course-card"
                    >
                      <el-button
                        @click="saveCourseApply()"
                        :disabled="saving"
                        type="primary"
                        size="medium"
                      >保存更新</el-button>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scope="">
#course-apply {
  .box-card{
    margin-top: 20px;

    &:first-of-type{
      margin-top: 0;
    }

    .hand{
      float: right;
    }
  }
  .loading {
    min-height: 100px;
  }
  .el-form-item__label {
    color: black;
  }
  .row-course-card {
    margin-top: 5px;
  }
  .label-not-exist {
    margin-left: 70px;
    color: #bcbcbc;
  }
  .phone-input > input {
    width: 300px;
  }
  .el-aside {
    background-color: #e1edf7;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  .el-main {
    background-color: #f9fbfd;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .el-form-item {
    margin-bottom: 0px;
    text-align: left;
  }
  .add-course-icon {
    color: blue;
    font-weight: bold;
    margin-left: 20px;
  }
  .img-completed {
    position: absolute;
  }
  .course-container {
    margin-left: 25px;
  }
  .text-right {
    text-align: right;
  }
  .delete-btn {
    color: red;
    cursor: pointer;
  }
  .hand {
    cursor: pointer;
  }
}
</style>

<script>
import navigator from "../../components/navigator";
import speedupCourseTrainingEditor from "../../components/training/speedupCourseEditor";
import {
  validateStudentByPhone,
  getStudentSpeedupCourseList,
  getCurrentNextTerms,
  getCourses,
  getTeacherByCourseId,
  saveStudentSpeedupCourse,
  getAllTrainingEnglishCourses
} from "../../service/speedupCourse.service";
import { getCampusList } from "../../service/common.service";

import Vue from "vue";
export default {
  components: {
    navigator,
    speedupCourseTrainingEditor
  },
  data() {
    return {
      saving: false,
      phone: "",
      validateExist: true,
      speedupCourseApplyList: [],
      englisthCourseList: [],
      trainingCourseList: [],
      loading: false,
      terms: [],
      courses: [],
      universityName: "",
      student: {},
      groupNumber: 0,
      trainingCourseCategroyList: [],
      englishCourseCategroyList: [],
      campusList: []
    };
  },
  created() {
    getCurrentNextTerms().then(result => {
      if (!!result && result.success) {
        this.terms = result.data;
      }
    });
    getAllTrainingEnglishCourses().then(result => {
      if (!!result && result.success) {
        this.englishCourseCategroyList = result.data[2];
        this.trainingCourseCategroyList = result.data[3];
      }
    });
    getCampusList().then(result => {
      if (!!result && result.success) {
        this.campusList = result.data;
      }
    });
  },
  methods: {
    async search() {
      this.speedupCourseApplyList = [];
      if (!this.phone || this.phone.trim().length == 0) {
        this.student.Id = -1;
        return;
      }

      await validateStudentByPhone(this.phone).then(result => {
        if (!!result && result.success) {
          if (result.data && result.data.Id > 0) {
            this.student = result.data;
            this.validateExist = true;
            if (this.student.University) {
              this.universityName = this.student.University.Name;
              this.groupNumber = this.student.University.GroupNumber;

              getCourses(this.groupNumber).then(result => {
                if (!!result && result.success) {
                  this.courses = result.data;
                }
              });
            }
          } else {
            this.validateExist = false;
          }
        }
      });

      if (!this.validateExist) {
        return;
      }

      this.loading = true;
      await getStudentSpeedupCourseList(this.phone).then(result => {
        if (!!result && result.success) {
          this.loadCourseList(result);
          this.loading = false;
        }
      }).catch(r=>{
        this.loading = false;
      });
    },
    loadCourseList(result){
      if (result.data && result.data.length > 0) {
        this.speedupCourseApplyList = result.data.filter(
          i => i.CourseType == 1
        );
        this.englisthCourseList = result.data.filter(
          i => i.CourseType == 2
        );
        this.trainingCourseList = result.data.filter(
          i => i.CourseType == 3
        );
      }else{
        this.speedupCourseApplyList = [];
        this.englisthCourseList = [];
        this.trainingCourseList = [];
      }
    },
    async onChangeCourseId(item, index) {
      await getTeacherByCourseId(item.CourseId).then(result => {
        if (!!result && result.success) {
          if (result.data.length <= 0) {
            // Vue.set(
            //   this.speedupCourseApplyList[index],
            //   "editingMessage",
            //   "该课程还未设置老师，不能报名该课程"
            // );
            // Vue.set(this.speedupCourseApplyList[index], "TeacherName", "");
            // Vue.set(this.speedupCourseApplyList[index], "TeacherId", "");
            // Vue.set(this.speedupCourseApplyList[index], "TeacherList", []);

            Vue.set(this.speedupCourseApplyList[index], "editingMessage", "");
            Vue.set(this.speedupCourseApplyList[index], "TeacherName", "");
            Vue.set(this.speedupCourseApplyList[index], "TeacherId", 0);
            Vue.set(this.speedupCourseApplyList[index], "TeacherList", []);
          } else {
            Vue.set(this.speedupCourseApplyList[index], "editingMessage", "");
            Vue.set(
              this.speedupCourseApplyList[index],
              "TeacherList",
              result.data
            );

            Vue.set(
              this.speedupCourseApplyList[index],
              "TeacherName",
              result.data[0].Name
            );
            Vue.set(
              this.speedupCourseApplyList[index],
              "TeacherId",
              result.data[0].Id
            );
          }
        }
      });
    },
    addCourse() {
      let item = this.getCourseNewItem(1);
      this.speedupCourseApplyList.splice(0, 0, item);
    },
    removeCourse(item, index) {
      this.$confirm("您确定要删除该课程吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.speedupCourseApplyList.splice(index, 1);
        })
        .catch(() => {});
    },
    async saveCourseApply() {
      let validate = true;
      this.saving = true;
      if (
        this.speedupCourseApplyList &&
        this.speedupCourseApplyList.length > 0
      ) {
        let i = -1;
        this.speedupCourseApplyList.forEach(r => {
          i++;
          Vue.set(this.speedupCourseApplyList[i], "editingMessage", "");

          // if (typeof r.TeacherId == "undefined" || r.TeacherId == 0) {
          //   Vue.set(
          //     this.speedupCourseApplyList[i],
          //     "editingMessage",
          //     "该课程还未设置老师，不能报名该课程"
          //   );
          //   validate = false;
          //   return;
          // }

          if (typeof r.TermId == "undefined" || r.TermId == 0) {
            Vue.set(
              this.speedupCourseApplyList[i],
              "editingMessage",
              "请设置学期"
            );
            validate = false;
            this.saving = false;
            return;
          }

          if (typeof r.CourseId == "undefined" || r.CourseId == 0) {
            Vue.set(
              this.speedupCourseApplyList[i],
              "editingMessage",
              "请设置课程"
            );
            validate = false;
            this.saving = false;
            return;
          }
        });
      }

      let trainingEditorList = this.$refs.trainingEditor;
      if (!!trainingEditorList){
        trainingEditorList.forEach(element => {
          if (!element.checkAllInputs()){
            validate = false;
          }
        });
      }
   
      if (!validate) {
        this.saving = false;
        return;
      }

      let list = this.speedupCourseApplyList.concat(this.trainingCourseList);
      list = list.concat(this.englisthCourseList);
      await saveStudentSpeedupCourse(
        this.student.Id,
        list
      ).then(result => {
        if (!!result && result.success) {
          this.$message("保存课程报名成功！");
          this.loadCourseList(result);
          // let idList = result.data;
          // if (!!idList && idList.length > 0) {
          //   for (let i = 0; i < this.speedupCourseApplyList.length; i++) {
          //     if (i < idList.length) {
          //       this.speedupCourseApplyList[i].Id = idList[i];
          //     }
          //   }
          // }
        } else {
          this.$message({
            message: result.message,
            type: "warning"
          });
        }
        this.saving = false;
      });
    },
    getCoursesByTermId(termId) {
      return this.courses.filter(r => r.TermId == termId);
    },
    changeTerm(item, index) {
      this.$set(this.speedupCourseApplyList[index], "CourseId", "");
    },
    onTrainingCourseRemove(index) {
      this.$confirm("您确定要删除该课程吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.trainingCourseList.splice(index, 1);
        })
        .catch(() => {});
    },
    addTrainingCourse(){
      let item = this.getCourseNewItem(3);
      this.trainingCourseList.splice(0, 0, item);
    },
    onEnglishCourseRemove(index) {
      this.$confirm("您确定要删除该课程吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.englisthCourseList.splice(index, 1);
        })
        .catch(() => {});
    },
    addEnglishCourse(){
      let item = this.getCourseNewItem(2);
      this.englisthCourseList.splice(0, 0, item);
    },
    getCourseNewItem(courseType){
      let item ={
        Id :0,
        StudentId: this.student.Id,
        UniversityName: this.universityName,
        CategoryId:"",
        CourseId :null,
        TermId :null,
        TeacherId:null,
        TeacherName :"",
        CourseType :courseType,
        CampusId :null,
      };
      return item;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/frontDesk/courseApply.vue